module.exports = __webpack_public_path__ + "img/icon_map_0_off_010.cb4be568.png";